export const ControlSize = {
    LARGE: 0,
} as const;

export type ControlSize = (typeof ControlSize)[keyof typeof ControlSize];
